import { useStore } from 'effector-react'
import { Button } from '~/shared/ui/Buttons'
import { Modal } from '~/shared/ui/Modal'
import { submitFx, submit } from './model'

type SendSelfEmployedModalProps = {
  isShow: boolean
  onClose: () => void
}

export function SendSelfEmployedModal({
  isShow,
  onClose,
}: SendSelfEmployedModalProps) {
  const isSubmitting = useStore(submitFx.pending)

  const handleSubmit = () => {
    submit({ fn: onClose })
  }

  return (
    <Modal isShow={isShow} canBackdropClose={false}>
      <div
        data-testid='modal-title'
        style={{ fontSize: '16px', fontWeight: '700', marginBottom: '8px' }}
      >
        Парковый Самозанятый
      </div>

      <div
        style={{ fontSize: '16px', marginBottom: '16px', lineHeight: '24px' }}
      >
        Отправить заявку на создание аккаунта
        <br />
        Процесс может занять до пяти минут
      </div>

      <Button
        variant='limeFlooded'
        fullWidth
        onClick={handleSubmit}
        loading={isSubmitting}
        style={{ marginBottom: '16px' }}
      >
        Подтвердить
      </Button>

      <Button
        fullWidth
        variant='lightSteelBlueBorder'
        onClick={onClose}
        disabled={isSubmitting}
      >
        Отмена
      </Button>
    </Modal>
  )
}
